module.exports = __webpack_public_path__ + "img/系统设置.bef02bdc.png";